import BeneficiaryFilterView from '@UI/Pages/Beneficiaries/BeneficiaryList/Filters/BeneficiaryFilterView';
import { createSignal } from '@verclam/pulsar';

const beneficiaryFiltersSignal = createSignal<BeneficiaryFilterView>(BeneficiaryFilterView.createDefault());

export const setBeneficiaryFilters = (filters: BeneficiaryFilterView): void => {
	beneficiaryFiltersSignal.value = filters;
};

export default beneficiaryFiltersSignal;
